import { render, staticRenderFns } from "./NewFormGroup.vue?vue&type=template&id=830759f4"
import script from "./NewFormGroup.vue?vue&type=script&lang=ts"
export * from "./NewFormGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830759f4')) {
      api.createRecord('830759f4', component.options)
    } else {
      api.reload('830759f4', component.options)
    }
    module.hot.accept("./NewFormGroup.vue?vue&type=template&id=830759f4", function () {
      api.rerender('830759f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/NewFormGroup.vue"
export default component.exports